import * as React from "react";
import {Button, FormGroup, Grid, Switch, TextField, FormControlLabel} from "@material-ui/core";
import {API} from "aws-amplify";
import {completeFillRequestDefault, ICompleteFillRequest} from "./request/CompleteFillRequest";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: ICompleteFillRequest
    response: any
}

enum InputField {
    FILL_ID,
    PERSON_ID,
    PRESCRIPTION_ID,
    PROFILE_ID,
    DATE_SHIP
}

class CompleteFillSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: completeFillRequestDefault,
            request: {} as ICompleteFillRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>

                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Fill Id"
                                variant="outlined"
                                value={ this.state.request.fillId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.FILL_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Person Id"
                                variant="outlined"
                                value={ this.state.request.personId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PERSON_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Prescription Id"
                                variant="outlined"
                                value={ this.state.request.prescriptionId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PRESCRIPTION_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Date Ship Complete in Local Time (Optional)"
                                type="datetime-local"
                                variant="outlined"
                                value={ this.state.request.dateShipComplete }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DATE_SHIP, event) }
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Complete Fill Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Complete Fill
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: ICompleteFillRequest = this.state.request;

        switch (field) {
            case InputField.FILL_ID: {
                updatedRequest.fillId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PERSON_ID: {
                updatedRequest.personId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PRESCRIPTION_ID: {
                updatedRequest.prescriptionId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.DATE_SHIP: {
                updatedRequest.dateShipComplete = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: ICompleteFillRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
        } else {
            body = this.state.request;
        }

        if (body.dateShipComplete !== undefined) {
            body.dateShipComplete = new Date(body.dateShipComplete).toISOString();
        }

        const config = {
            body,
            headers: {}
        }

        this.callCompleteFill(config);

        this.setState({ isLoading: false });
    }

    private callCompleteFill(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/fills/complete';

        console.log(config)
        API.post(apiName, path, config).then((completeFillResponse: any) => {
            console.log(completeFillResponse);

            this.setState({ response: completeFillResponse });
        }).catch((error) => {
            console.log(error);

            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default CompleteFillSection;